export const FULL_SIGN_OUT_STATE_KEY = 'mythic_full_sign_out_state';
export const FULL_SIGN_OUT_STATES = Object.freeze({
    IN_PROGRESS: 'in-progress',
    COMPLETED: 'completed',
    FAILED: 'failed'
});

const BRIDGE_STORAGE_PREFIX = 'mythic_clerk_bridge_';

export function markFullSignOutInProgress() {
    sessionStorage.setItem(FULL_SIGN_OUT_STATE_KEY, FULL_SIGN_OUT_STATES.IN_PROGRESS);
}

export function markFullSignOutCompleted() {
    sessionStorage.setItem(FULL_SIGN_OUT_STATE_KEY, FULL_SIGN_OUT_STATES.COMPLETED);
}

export function markFullSignOutFailed() {
    sessionStorage.setItem(FULL_SIGN_OUT_STATE_KEY, FULL_SIGN_OUT_STATES.FAILED);
}

export function getFullSignOutState() {
    const state = sessionStorage.getItem(FULL_SIGN_OUT_STATE_KEY);
    if (state === null) return null;
    if (!Object.values(FULL_SIGN_OUT_STATES).includes(state)) {
        throw new Error(`Invalid full sign-out state marker: ${state}`);
    }
    return state;
}

export function isFullSignOutBlocked() {
    return getFullSignOutState() !== null;
}

export function clearCompletedFullSignOutAfterClerkIsSignedOut() {
    if (getFullSignOutState() === FULL_SIGN_OUT_STATES.COMPLETED) {
        sessionStorage.removeItem(FULL_SIGN_OUT_STATE_KEY);
    }
}

export function clearFullSignOutState() {
    sessionStorage.removeItem(FULL_SIGN_OUT_STATE_KEY);
}

export function clearClerkBridgeStorage() {
    Object.keys(sessionStorage)
        .filter((key) => key.startsWith(BRIDGE_STORAGE_PREFIX))
        .forEach((key) => sessionStorage.removeItem(key));
}
